import {Link} from 'react-router-dom'

export function Error500() {
  return (
    <main className='education-error-page'>
      <section className='education-error-card' aria-labelledby='error-title'>
        <span className='error-code'>500</span>
        <h1 id='error-title'>İşlem şu anda tamamlanamıyor</h1>
        <p>Geçici bir sorun oluştu. Sayfayı yeniden yükleyebilir veya sınıfınıza dönebilirsiniz.</p>
        <div className='error-actions'>
          <button type='button' className='btn btn-light' onClick={() => window.location.reload()}>Yeniden yükle</button>
          <Link to='/dashboard' className='btn btn-primary'>Sınıfıma dön</Link>
        </div>
      </section>
    </main>
  )
}
